<template>
  <div forgot-password>
    <Layout
      :app="app"
      header="Forgot password"
      title="Reset your password"
    >
      <template v-slot:desc>
        Enter your email address below and we'll send you password reset instructions
      </template>

      <ul
        v-if="errors"
        class="error"
      >
        <li
          v-for="err in errors"
          :key="err.message"
        >
          {{ err.message }}
        </li>
      </ul>

      <div
        v-if="completed"
        class="completed"
      >
        If a matching account was found, instructions have been sent to "{{ sentToEmail }}".<br>
        Please check your inbox.
      </div>

      <Input
        v-model="email"
        :autofocus="true"
        class="input"
        label="Email address"
        type="email"
        placeholder="me@company.com"
        @enter="submit"
      />

      <div
        v-if="loading"
        class="loading"
      >
        <Spinner />
      </div>
      <Button
        v-else
        class="button"
        label="Send Instructions"
        @click="submit"
      />

      <div
        v-if="app && !isAdminApp"
        class="links"
      >
        <a
          class="link"
          :href="app && app.url"
        >Back to {{ app.name }}</a>
        <router-link
          class="link"
          :to="`/${appKey}/sign-in`"
        >
          Sign In
        </router-link>
      </div>
    </Layout>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { ADMIN_APP_KEY } from '@/globals';
  import Layout from './layout.vue';
  import Input from '../../components/input.vue';
  import Button from '../../components/button.vue';
  import Spinner from '../../components/spinner.vue';
  import app from '../../mixins/app';

  export default {
    name: 'ForgotPassword',
    components: {
      Layout,
      Input,
      Button,
      Spinner,
    },
    mixins: [app],
    data() {
      return {
        email: '',
        errors: null,
        loading: false,
        completed: false,
        sentToEmail: null,
      };
    },
    computed: {
      isAdminApp() {
        return this.appKey === ADMIN_APP_KEY;
      },
    },
    methods: {
      submit() {
        if (!this.email) {
          this.errors = [{ message: 'Please enter a valid email address' }];
          return;
        }
        this.errors = null;
        this.loading = true;
        this.$apollo.mutate({
          mutation: gql`mutation ($email: String!, $key: String) {
          forgotPassword (email: $email, key: $key)
        }`,
          variables: {
            email: this.email,
            key: this.appKey,
          },
        }).then(() => {
          this.loading = false;
          this.completed = true;
          this.sentToEmail = this.email;
          this.email = '';
        }).catch((error) => {
          this.loading = false;
          this.errors = error.graphQLErrors;
        });
      },
    },
  };
</script>

<style scoped lang="stylus">
  @require '~@/style/colors'
  @require '~@/style/type'

  .input
    margin-top: 30px
    &:first-of-type
      margin-top: 0

  .button, .loading
    width: 100%
    margin-top: 60px

  .loading
    height: 50px
    display: flex
    align-items: center
    justify-content: center

  .links
    @extend $type-small
    display: block
    width: 100%
    text-align: center
    margin-top: 30px
    a
      display: inline-block
      margin-left: 10px
      padding-right: 10px
      border-right: 1px solid #aaa
      &:last-of-type
        border-right: none

  .error
    @extend $type-small, $type-medium
    color: #a00
    background-color: rgba(205,92,92,.1)
    text-align: center
    list-style: none
    margin: 0 0 20px 0
    padding: 10px

  .completed
    @extend $type-small, $type-medium
    color: #060
    background-color: rgba(92,205,92,.1)
    text-align: center
    list-style: none
    margin: 0 0 20px 0
    padding: 10px

</style>
